<template lang="pug" src="./custom-smile-gallery.pug"></template>

<script>
import { onScroll } from 'resources/mixins'

export default {
  data () {
    return {
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.5]
      },
      swiperOption: {
        touchEventsTarget: 'wrapper',
        loop: true,
        autoplay: {
          delay: 3000
        },
        centeredSlides: true,
        spaceBetween: 24,
        slidesPerView: 3,
        speed: 650,
        slideActiveClass: 'custom-smile-gallery__swiper-slide--active',
        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 24,
            centeredSlides: false
          }
        },
        pagination: {
          el: '.custom-smile-gallery__pagination',
          clickable: true,
          bulletClass: 'custom-smile-gallery__bullet',
          bulletActiveClass: 'custom-smile-gallery__bullet--active'
        }
      }
    }
  },
  props: ['props'],
  mixins: [onScroll],
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    slidePrev () {
      this.swiper.slidePrev()
    },
    slideNext () {
      this.swiper.slideNext()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-smile-gallery/custom-smile-gallery.vue